/**
 * 判断当前餐厅是否允许使用 Fiskaly 功能。
 * @param countryCode - 当前餐厅国际电话区号。
 * @returns 仅西班牙区号 `+34` 返回 true。
 */
export function isFiskalyAvailableForRestaurant(countryCode: unknown): boolean {
    return countryCode === '+34';
}
